import React, { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import "@styles/pages/Login/Login.scss";
import { Box, Typography } from "@mui/material";
import ClubsLogin from "@pages/Login/Clubs/ClubsLogin";
import SamsungAccountLogin from "@pages/Login/Samsung/SamsungAccountLogin";
import { useNavigate } from "react-router-dom";
import { Trans, useTranslation } from "react-i18next";
import { resetFormStep } from "@store/ui/formStepSlice";
const Login = () => {
  const { t, i18n } = useTranslation();
  const currentStep = useSelector((state) => state.formStep.clubSLogin);
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(resetFormStep({ formKey: "clubSLogin" }));
    dispatch(resetFormStep({ formKey: "redeem" }));
  }, []);

  return (
    <Box className="login-container">
      <Box className="login-detail-container">
        <Box className="logo-container">
          <img
            className="logo"
            src={`${process.env.PUBLIC_URL}/assets/images/global/mobile_logo.png`}
            alt="logo"
          />
        </Box>
        {currentStep == 0 && (
          <>
            <Typography className="other-login-text">
              <Trans i18nKey="login:or_login_with_sa" />
            </Typography>
            <Typography className="sa-login-text">
              <Trans i18nKey="login:sa_login" />
            </Typography>
            <SamsungAccountLogin />
          </>
        )}
        <br /><br />
         <ClubsLogin />
      </Box>
    </Box>
  );
};

export default Login;
